import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Menu, X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";

import { ProfileOptions } from "../ProfileOptions";

import { Button } from "../DesignSystem/";

import logoPagdealSvg from "../../assets/logo-vibra.svg";
import logoPagdealPng from "../../assets/logo-vibra.png";

import "./index.scss";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.app);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [className, setClassName] = useState("header__nav");
  const userPermission = user?.roles_id;

  function handleToggleMenu() {
    setMenuIsOpen(!menuIsOpen);
  }

  useEffect(() => {
    if (menuIsOpen) {
      setClassName("header__nav header__nav--active");
    } else {
      setClassName("header__nav");
    }
  }, [menuIsOpen]);

  function handleNavigate(path) {
    dispatch({ type: "RESET_KEYWORD" });
    navigate(path);
    setMenuIsOpen(false);
  }

  function handleLogout() {
    localStorage.removeItem("user");
    localStorage.removeItem("goto");
    dispatch({ type: "CHANGE_USER", user: null });
    dispatch({ type: "RESET_CHARGE_INFO" });
    navigate("/login");
  }

  return (
    <header className="header">
      <div className="header__logo">
        <picture>
          <source type="image/svg+xml" srcSet={logoPagdealSvg} />
          <img src={logoPagdealPng} alt="Vibra" />
        </picture>
      </div>
      {(userPermission === 1 || userPermission === 2) && (
        <>
          <ul className={className}>
            <div className="header__nav__logo">
              <picture>
                <source type="image/svg+xml" srcSet={logoPagdealSvg} />
                <img src={logoPagdealPng} alt="Vibra" />
              </picture>
              <X onClick={handleToggleMenu} />
            </div>
            <li onClick={() => handleNavigate("/painel/meus-casos")}>
              Meus casos
              <ChevronRight />
            </li>
            <li onClick={() => handleNavigate("/painel/meus-casos-new")}>
              Informações
              <ChevronRight />
            </li>
            <li onClick={() => handleNavigate("/painel/reports")}>
              Métricas
              <ChevronRight />
            </li>
            {/* <li onClick={() => handleNavigate("#")}>
              Lista de Casos
              <ChevronRight />
            </li> */}
            {/* 
            <li onClick={() => window.open("/painel/novo-caso", "_blank")}>
              Inserir caso
              <ChevronRight />
            </li> */}
            <div className="header__nav__logout">
              <Button contained fullWidth>
                Logout
              </Button>
            </div>
          </ul>
          <div className="header__icons">
            <div className="header__menu">
              <Menu onClick={handleToggleMenu} />
            </div>
            <ProfileOptions />
          </div>
        </>
      )}
      {userPermission === 3 && (
        <>
          <ul className={className}>
            <div className="header__nav__logout">
              <Button contained fullWidth>
                Logout
              </Button>
            </div>
          </ul>
          <div className="header__icons">
            <div className="header__menu">
              <Menu onClick={handleToggleMenu} />
            </div>
            <ProfileOptions />
          </div>
        </>
      )}
    </header>
  );
}

export default Header;
